import Button from './Button.vue';

export default Button;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/cards/purchases/components/cancellation/components/button/index.ts